import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";
import { getFormatDate } from "~/libs/getFormatDate";
import StatusResolver from "~/pages/CameraZonesView/parts/StatusResolver";

export const getCameraZoneColumns = (t: TFunction): ColumnsType<any> => [
  {
    title: t("cameraView.table.id"),
    dataIndex: "id",
    key: "id",
  },
  {
    title: t("cameraView.table.name"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: t("cameraView.table.createdAt"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (value: string) => getFormatDate(value),
  },
  {
    title: t("cameraView.table.createdBy"),
    dataIndex: "createdBy",
    key: "createdBy",
  },
];

export const getCameraColumns = (t: TFunction): ColumnsType<any> => [
  {
    title: t("cameraView.table.id"),
    dataIndex: "id",
    key: "id",
  },
  {
    title: t("cameraView.table.name"),
    dataIndex: "name",
    key: "name",
  },
  {
    title: t("cameraView.table.createdAt"),
    dataIndex: "createdAt",
    key: "createdAt",
    render: (value: string) => getFormatDate(value),
  },
  {
    title: t("cameraView.table.createdBy"),
    dataIndex: "createdBy",
    key: "createdBy",
  },
  {
    title: t("cameraView.table.status"),
    dataIndex: "status",
    key: "status",
    render: (value: string) => <StatusResolver status={value} />,
  },
];
